import { TokenSession } from 'urbnTokenLib';
import { scopeTypes } from '../constants';

export function isAuthorized() {
    const ts = TokenSession.fromCookie();
    return ts.hasScope(scopeTypes.AUTHORIZED);
}
